import { NgModule } from '@angular/core';
import { type Route, RouterModule, type Routes } from '@angular/router';
import { FeatureEnabledGuard } from '@principle-theorem/ng-feature-flags';
import { AiSuiteDefaultChildResolver } from './ai-suite-default-child.resolver';
import { AI_SUITE_FEATURES } from './ai-suite-feature-registry';
import { AiSuiteShellComponent } from './ai-suite-shell.component';

const featureRoutes: Route[] = AI_SUITE_FEATURES.map((feature) => ({
  path: feature.id,
  canActivate: [FeatureEnabledGuard],
  data: { title: feature.label, feature: feature.feature },
  loadComponent: feature.loadComponent,
}));

const routes: Routes = [
  {
    path: '',
    component: AiSuiteShellComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [AiSuiteDefaultChildResolver],
        children: [],
      },
      ...featureRoutes,
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AiSuiteRoutingModule {}
